export const TITLE_TYPING_LIMIT = 50;
